import medpointLogo from "../../images/medpoint-logo-rev-257x32.png";
import styles from './SplashScreen.module.scss';
import { ProgressBar } from './ProgressBar';

export function SplashScreen(props: {
    noAnimation?: boolean;
}) {

    let splashClass = `${styles.splashScreen} ${props.noAnimation ? styles.noAnimation : styles.reactReady}`;
    return (
        <section
            className={splashClass}>
            <div className={styles.inner}>
                <div className={styles.logo}>
                    <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
                    <img src={medpointLogo} />
                </div>
                <ProgressBar noAnimation={props.noAnimation} width={600} fadeInDelay={450} />
            </div>
        </section>
    );
}
